// Returns the file-type filters with the currently selected ones first, preserving
// relative order. Never mutates the input, and returns the SAME array reference when
// the order is already correct so callers can skip a redundant state update / re-render.
export function sortFileTypesBySelection(filters, selectedFileTypes = []) {
  if (!filters) {
    return filters
  }

  const sorted = [...filters].sort(
    (a, b) => selectedFileTypes.includes(b.value) - selectedFileTypes.includes(a.value)
  )

  const orderUnchanged = sorted.every((filter, index) => filter === filters[index])

  return orderUnchanged ? filters : sorted
}
